export default "__VITE_ASSET__CWqBfZIZ__"